import './_search-input.twig';
import './_search-input.scss';

export function enable() {}

export default enable;
